import * as Yup from 'yup';
import { MESSAGE_INVALID_LETTER_NUMBER, MESSAGE_REQUIRED } from '@/utils/validation-utils';

export const letterNumberSchema: Yup.StringSchema = Yup.string()
  .transform((value: string | undefined) => {
    return value ? value.replace(/[^0-9]/g, '') : '';
  })
  .required(MESSAGE_REQUIRED)
  .test('is-valid-number', MESSAGE_INVALID_LETTER_NUMBER, (value: string | undefined) => {
    if (!value || value.trim() === '') {
      return false;
    }
    const numericValue: number = parseInt(value, 10);
    return !isNaN(numericValue) && numericValue > 0;
  });
